import { ContentAreaBlock } from '@lg/shared/for-studio'
import type { ScreenBlock } from '@lg/shared'
import type { EditorPropertyWithKey } from '@lg/shared'
import type { Screen } from '@lg/shared'
import type { BoReference } from '@lg/shared'
import { ScreenItemEditorHelper } from './screen-item-editor-helper'
import { Injectable } from '@angular/core'

@Injectable({
	providedIn: 'root',
})
export class ScreenBlockEditorHelper extends ScreenItemEditorHelper<
	Screen,
	ScreenBlock
> {
	protected getInputAssignmentMap(item: ScreenBlock): Map<string, string> {
		return item.assignments
	}

	protected getOutputAssignmentMap(item: ScreenBlock): Map<string, string> {
		return new Map()
	}

	protected async updateScreenAssignments(
		item: ScreenBlock,
		allProperties: EditorPropertyWithKey<Screen, ScreenBlock>[],
	) {
		const inputs = await super.updateScreenAssignments(item, allProperties)

		const boDetailsList =
			await this.getBoSpecificDetailsForReferencedItems(item)
		for (const boDetails of boDetailsList) {
			// add missing content areas
			for (const placeholder of boDetails?.placeholders ?? []) {
				if (!item.getContentArea(placeholder)) {
					item.children.push(new ContentAreaBlock({ name: placeholder }))
				}
			}
		}

		return inputs
	}

	protected getScreenRef(item: ScreenBlock): BoReference<'Screen'> {
		return item.screenRef
	}

	protected async getRefsToReferencedBos(
		item: ScreenBlock,
	): Promise<BoReference[]> {
		return item.needsBoSpecificDetailsForRefs()
	}
}
